import React from 'react';
import { Card } from '../../../components/ui/card';
import { HelpTip } from './HelpTip';
import { fmtNum } from './kpiUtils';
import { fmtHoras, fmtPct } from './atencionUtils';
import { ColumnasSelector, useColumnas } from './ColumnasSelector';
import { TablaAtencion } from './TablaAtencion';

const COLUMNAS = [
  { key: 'grupo', label: 'Grupo', fija: true, className: 'font-medium text-slate-800' },
  { key: 'tickets', label: 'Tickets', right: true, render: (g) => fmtNum(g.tickets) },
  { key: 'abiertos', label: 'Abiertos', right: true, render: (g) => fmtNum(g.abiertos) },
  {
    key: 'sla', label: 'SLA violado', right: true, className: (g) => (g.sla_alerta ? 'font-bold text-red-600' : ''),
    render: (g) => <span data-testid={`atencion-grupo-sla-${g.grupo}`}>{fmtPct(g.sla_violado_pct)} <span className="text-xs font-normal text-slate-400">({fmtNum(g.sla_con_dato)})</span></span>,
  },
  { key: 'mediana', label: 'Mediana resolución', right: true, render: (g) => fmtHoras(g.mediana_resolucion_h) },
  { key: 'p90', label: 'P90 resolución', right: true, render: (g) => fmtHoras(g.p90_resolucion_h) },
  {
    key: 'primera', label: '1ra respuesta prom.', right: true,
    render: (g) => <>{fmtHoras(g.primera_respuesta_prom_h)} <span className="text-xs text-slate-400">sobre {fmtNum(g.primera_respuesta_n)}</span></>,
  },
];

// B3: tabla por grupo. SLA violado > 30 % en rojo.
export const AtencionGrupos = ({ grupos = [] }) => {
  const cols = useColumnas('grupos', COLUMNAS);
  return (
    <Card className="mb-6 p-5 lg:p-6" data-testid="atencion-grupos">
      <div className="mb-4 flex items-center gap-2">
        <h2 className="text-base font-semibold text-slate-800">Por grupo</h2>
        <HelpTip testId="atencion-grupos-help" text="Mediana y percentil 90 sin cierres automáticos (menos de 1 minuto). La 1ra respuesta promedio solo usa tickets con dato real. SLA violado sobre los tickets con estado de SLA; en rojo si supera el 30 %." />
        <div className="ml-auto"><ColumnasSelector columnas={COLUMNAS} estado={cols} testId="atencion-grupos-cols" /></div>
      </div>
      <TablaAtencion columnas={COLUMNAS} ver={cols.ver} filas={grupos} rowKey={(g) => g.grupo}
        rowTestId={(g) => `atencion-grupo-${g.grupo}`} vacio="Sin tickets en el período." />
    </Card>
  );
};
